var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0"},[_c('title',{staticClass:"text-no-wrap ma-0 pa-0",attrs:{"hieght":"60"}},[_vm._v(" "+_vm._s(_vm.pokemonType.name)+" ")]),_c('v-img',{staticClass:"self-center",attrs:{"src":_vm.getIcon(),"contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }